<template>
  <div
    class="p-checkbox form-check d-flex align-items-center m-auto"
    :class="className"
  >
    <input
      :id="id || name"
      :name="name"
      :checked="internalValue"
      :indeterminate.prop="indeterminate"
      type="checkbox"
      class="form-check-input"
      v-bind="inputProps"
      :disabled="disabled"
      @click="handleClick"
    >
    <label
      :for="id || name"
      class="form-check-label ms-2"
    >
      <slot />
    </label>
  </div>
</template>

<script>
import { debounce } from 'lodash'
export default {
  name: 'Checkbox',
  props: {
    id: { type: String, default: null },
    name: { type: String, default: 'checkbox' },
    className: { type: String, default: '' },
    value: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    inputProps: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    internalValue: false
  }),
  watch: {
    value (val) {
      this.internalValue = val
    },
    checked (val) {
      this.internalValue = val
    },
    internalValue (val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
      }
    }
  },
  created () {
    // Each checkbox settles its own rapid clicks, so ticking one never discards another's.
    this.handleClick = debounce(this.emitSelection, 100)
  },
  mounted () {
    this.internalValue = this.value

    if ('checked' in this.$options.propsData) {
      this.internalValue = this.checked
    }
  },
  methods: {
    emitSelection (e) {
      if (!e.isPropagationStopped) {
        this.internalValue = e.target.checked
      }

      this.$emit('click', {
        event: e,
        value: this.internalValue
      })

      this.$emit('change', {
        event: e,
        value: this.internalValue
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.p-checkbox {
  .form-check-input {
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 0;
    border: 1px solid #383838;
    margin-top: auto;
    margin-bottom: auto;

    &:checked, &:indeterminate {
      background-color: #383838;
      border-color: #383838;
    }
  }

  .form-check-label {
    font: normal normal normal 14px/16px Arial;
    letter-spacing: 0;
    color: black;
    white-space: normal;
    text-align: left;
  }
}
</style>
